import { toast } from "react-toastify";
import { getFacebookExchangeTokenData, getFigmaObj, postFacebookBusinessAuth, postFacebookCreateCatalog, postFacebookListBusinesses, postFacebookListCatalogs, postFacebookRefreshBusinesses, postFacebookRefreshCatalogs, postFacebookUserAuth, postPublish, postPublishesCreatives, putCreative } from "../../../helpers/backend_helper";
import { setCampaignLoader, setFacebookPublishMessage } from "../../campaigns/reducer";
import { toggleFacebookPublishSuccessModal } from "../../modals/reducer";
import { loadFonts } from "../../fonts/thunk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';
import { setIsBusinessAuthenticated, setPublishedCreatives, setUserFacebookId } from "../reducer";
import { push, replace } from "redux-first-history";
import { checkMaintenance } from "../../auth/login/helper";
import { openCampaign, updateVersionStatusAfterUpdate } from "../../campaigns/thunk";
import { setBreadcrumb } from "../../auth/menu/reducer";

export const publishFacebook = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { currentCampaign, currentVersion, creatives, facebookId, facebookCreativeIds } = getState().Campaign;
    const updatedCreatives = [];
    if (creatives.length > 0) {
      // let i = 0;
      // do {
      //   const creative = creatives[i];
      //   if (creatives.hasOwnProperty('figmaObject')) {
      //     updatedCreatives.push(creative);
      //   } else {
      //     let updatedCreative = { ...creative, preview: null };
      //     updatedCreative.figmaObject = await getFigmaObj(updatedCreative.figma + `?timestamp=${new Date().getTime()}`);
      //     const fonts = await dispatch(loadFonts(updatedCreative.figmaObject));
      //     updatedCreative.figmaObject.node.googlefont.style = fonts;
      //     updatedCreative.figmaObject.node.adcfont.style = fonts;
      //     updatedCreatives.push(updatedCreative);
      //   }
      //   i++;
      // } while (i < creatives.length);
      // const creativeRes = await putCreative({ creativeArray: updatedCreatives, campaignId: currentCampaign._id });
      const res = await postPublish({
        campaignId: currentCampaign._id,
        versionId: creatives[0].versionId,
        creativeIds: facebookCreativeIds,
        publishType: 'facebookScript',
        templateType: 'figma',
        facebookPropertiesId: facebookId,
      });
      if (res.status === 'ok') {
        // toast.success(res.message, {autoClose: 3000});
        dispatch(setFacebookPublishMessage(res.data.data.result.cloudPath));
        dispatch(toggleFacebookPublishSuccessModal());
      } else {
        throw res;
      }
    }
  } catch (error) {
    // console.log('error', error);
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

// Facebook Catalog

export const createFacebookUserAuth = () => async (dispatch, getState) => {
  try {
    const { marketPath } = getState().MenuData;
    const {
      versions,
      currentVersion,
      currentCampaign,
      creatives,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      connectedFeed,
      connectedFeedName,
      facebookId
    } = getState().Campaign;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        id: getState().Campaign.id,
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brandId: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    const {
      whereToPublish,
      publishTypes,
      selectedPublishType,
      userFacebookId,
      fbCatalogPublishSettings,
      selectedCreativesPublish,
      businessList,
      catalogList
    } = getState().Publish;
    const res = await postFacebookUserAuth({
      marketId: marketPath
    });
    if (res.status === 'ok') {
      if (res.message === 'fb_user_auth_need') {
        Cookies.set('lastLocation', window.location.origin + window.location.pathname, { expires: 2 });
        localStorage.setItem('publishObj', JSON.stringify({
          toastMessage: 'User authentication success.',
          versions: versions,
          currentVersion: currentVersion,
          currentCampaign: currentCampaign,
          publishList: publishTypes,
          creatives: (creatives || []).map((item) => {
            let returnObj = {};
            let keys = Object.keys(item);
            keys.forEach(key => {
              if (key !== 'preview' && key !== 'figmaObject') {
                returnObj[key] = item[key];
              }
            });
            return returnObj;
          }),
          publishType: null,
          connectedFeed: connectedFeed,
          connectedFeedName: connectedFeedName,
          whereToPublish: true,
          userFacebookId: userFacebookId,
          facebookProperties: facebookProperties,
          facebookStatus: facebookStatus,
          facebookCreativeIds: facebookCreativeIds,
          fbCatalogPublishSettings: fbCatalogPublishSettings,
          selectedCreativesPublish: creatives.filter(creative => facebookCreativeIds.includes(creative._id)),
          isBusinessAuthenticated: false,
          businessList: businessList,
          catalogList: catalogList
        }));
        window.location.href = res.data
      } else if (res.message === 'fb_user_authenticated') {
        dispatch(setUserFacebookId(res.data._id));
        dispatch(push(window.location.origin + window.location.pathname + `?type=facebookCatalog`, {
          versions: versions,
          currentVersion: currentVersion,
          currentCampaign: currentCampaign,
          publishList: publishTypes,
          creatives: (creatives || []).map((item) => {
            let returnObj = {};
            let keys = Object.keys(item);
            keys.forEach(key => {
              if (key !== 'preview') {
                returnObj[key] = item[key];
              }
            });
            return returnObj;
          }),
          publishType: selectedPublishType,
          connectedFeed: connectedFeed,
          connectedFeedName: connectedFeedName,
          whereToPublish: whereToPublish,
          userFacebookId: res.data._id,
          facebookProperties: facebookProperties,
          isFacebookPropertiesSet: isFacebookPropertiesSet,
          facebookStatus: facebookStatus,
          facebookCreativeIds: facebookCreativeIds,
          selectedCreativesPublish: creatives.filter(creative => facebookCreativeIds.includes(creative._id)),
        }))
      }
    } else {
      toast.error(language[res?.code], { autoClose: 3000 });
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log('error', error);
  }
};

export const exchangeToken = (query) => async (dispatch, getState) => {
  try {
    const res = await getFacebookExchangeTokenData(query);
    return res;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const getFacebookBusinessesList = createAsyncThunk("facebookCatalog/getFacebookBusinessesList", async (params, { dispatch, getState }) => {
  const language = getState().MenuData.language;
  try {
    const { marketPath } = getState().MenuData;
    const { userFacebookId } = getState().Publish;
    const res = await postFacebookListBusinesses({
      marketId: marketPath,
      userFacebookId: userFacebookId
    });
    // console.log("res", res);
    if (res.status === 'ok') {
      return res.data;
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    checkMaintenance(dispatch, error);
    return [];
  }
});

export const refreshFacebookBusinessList = createAsyncThunk('facebookCatalog/refreshFacebookBusinessList', async (params, { dispatch, getState }) => {
  const language = getState().MenuData.language;
  try {
    const { marketPath } = getState().MenuData;
    const { userFacebookId } = getState().Publish;
    const res = await postFacebookRefreshBusinesses({
      marketId: marketPath,
      userFacebookId: userFacebookId
    });
    if (res.status === 'ok') {
      return res.data.map(item => {
        return { ...item, businessId: item.id }
      });
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    checkMaintenance(dispatch, error);
    return [];
  }
});

export const createFacebookBusinessAuth = () => async (dispatch, getState) => {
  const language = getState().MenuData.language;
  try {
    const { marketPath } = getState().MenuData;
    const {
      versions,
      currentVersion,
      creatives,
      currentCampaign,
      connectedFeed,
      connectedFeedName,
      facebookId,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds
    } = getState().Campaign;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        id: getState().Campaign.id,
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brandId: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    const {
      whereToPublish,
      publishTypes,
      selectedPublishType,
      userFacebookId,
      fbBusinessId,
      catalogId,
      fbCatalogPublishSettings,
      selectedCreativesPublish,
      businessList,
      catalogList
    } = getState().Publish;
    const res = await postFacebookBusinessAuth({ marketId: marketPath });
    if (res.status === 'ok') {
      if (res.message === 'fb_user_auth_need') {
        Cookies.set('lastLocation', window.location.href, { expires: 2 });
        localStorage.setItem('publishObj', JSON.stringify({
          toastMessage: 'Business successfully authenticated. You can publish now.',
          versions: versions,
          currentVersion: currentVersion,
          currentCampaign: currentCampaign,
          publishList: publishTypes,
          creatives: (creatives || []).map((item) => {
            let returnObj = {};
            let keys = Object.keys(item);
            keys.forEach(key => {
              if (key !== 'preview' && key !== 'figmaObject') {
                returnObj[key] = item[key];
              }
            });
            return returnObj;
          }),
          publishType: selectedPublishType,
          connectedFeed: connectedFeed,
          connectedFeedName: connectedFeedName,
          whereToPublish: whereToPublish,
          userFacebookId: userFacebookId,
          catalogId: catalogId,
          fbBusinessId: fbBusinessId,
          facebookProperties: facebookProperties,
          isFacebookPropertiesSet: isFacebookPropertiesSet,
          facebookStatus: facebookStatus,
          facebookCreativeIds: facebookCreativeIds,
          fbCatalogPublishSettings: fbCatalogPublishSettings,
          selectedCreativesPublish: selectedCreativesPublish,
          isBusinessAuthenticated: true,
          businessList: businessList,
          catalogList: catalogList
        }));
        window.location.href = res.data
      }
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log('error', error);
    checkMaintenance(dispatch, error);
  }
}

export const getFacebookCatalogList = createAsyncThunk('facebookCatalog/getFacebookCatalogList', async (params, { dispatch, getState }) => {
  const language = getState().MenuData;
  try {
    const { marketPath } = getState().MenuData;
    const { userFacebookId, fbBusinessId } = getState().Publish;
    let businessIdVar = params?.businessId ? params?.businessId : fbBusinessId
    const res = await postFacebookListCatalogs({
      marketId: marketPath,
      userFacebookId: userFacebookId,
      fbBusinessId: businessIdVar
    });
    if (res.status === 'ok') {
      return res.data;
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
    checkMaintenance(dispatch, error);
  }
});

export const refreshFacebookCatalogList = createAsyncThunk('facebookCatalog/refreshFacebookCatalogList', async (params, { dispatch, getState }) => {
  const language = getState().MenuData;
  try {
    const { marketPath } = getState().MenuData;
    const { userFacebookId, fbBusinessId } = getState().Publish;
    const res = await postFacebookRefreshCatalogs({
      marketId: marketPath,
      userFacebookId: userFacebookId,
      fbBusinessId: fbBusinessId
    });
    if (res.status === 'ok') {
      return res.data.map(item => {
        return { ...item, catalogId: item.id }
      });
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
    checkMaintenance(dispatch, error);
  }
});

export const createFacebookCatalog = (name) => async (dispatch, getState) => {
  const language = getState().MenuData.language;
  try {
    const { marketPath } = getState().MenuData;
    const { userFacebookId, fbBusinessId } = getState().Publish;
    const res = await postFacebookCreateCatalog({
      marketId: marketPath,
      userFacebookId: userFacebookId,
      fbBusinessId: fbBusinessId,
      catalogName: name
    });
    if (res.status === 'ok') {
      dispatch(refreshFacebookCatalogList());
      dispatch(setIsBusinessAuthenticated(false));
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
    checkMaintenance(dispatch, error);
  }
};

export const publishFacebookCatalog = () => async (dispatch, getState) => {
  const { language, marketPath } = getState().MenuData;
  try {
    const { currentCampaign, currentVersion, facebookId, facebookCreativeIds } = getState().Campaign;
    const {
      selectedCreativesPublish,
      userFacebookId,
      fbBusinessId,
      catalogId,
      catalogList
    } = getState().Publish;
    const foundCatalog = catalogList.find(catalog => catalog.catalogId === catalogId);
    const res = await postPublish({
      campaignId: currentCampaign._id,
      publishType: 'facebookCatalog',
      userFacebookId: userFacebookId,
      fbBusinessId: fbBusinessId,
      fbCatalogId: catalogId,
      templateType: 'figma',
      marketId: marketPath,
      versionId: selectedCreativesPublish[0].versionId,
      facebookPropertiesId: facebookId,
      creativeIds: facebookCreativeIds,
      feedName: foundCatalog.name
    });
    if (res.status === 'ok') {
      setTimeout(() => {
        toast.success('Successfully Published.', { autoClose: 3000 });
      }, 100);
    } else {
      throw res;
    }
  } catch (error) {
    toast.error("Something went wrong.", { autoClose: 3000 });
    // console.log(error);
    checkMaintenance(dispatch, error);
  }
};

export const pushChangesSocial = () => async (dispatch, getState) => {
  const { language, marketPath } = getState().MenuData;
  try {
    const {
      currentCampaign,
      currentVersion,
      creatives,
      facebookProperties,
      isFacebookPropertiesSet,
      connectedFeed,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      uploadLimits,
      facebookId,
      facebookCreativeIds
    } = getState().Campaign;
    const {
      fbBusinessId,
      catalogId,
    } = getState().Publish;
    let userFacebookId;
    if (creatives.length > 0) {
      const res = await postPublishesCreatives({
        creativeIds: facebookCreativeIds,
        versionId: creatives[0].versionId,
        type: 'facebook'
      });
      let error = null;
      if (res.status === 'ok') {
        const scriptPublish = [];
        let scriptRes;
        const catalogPublish = [];
        let i = 0;
        do {
          const resDataObj = res.data[i];
          if (resDataObj.publishType === 'facebookScript') {
            scriptPublish.push(resDataObj);
          } else if (resDataObj.publishType === 'facebookCatalog') {
            const authRes = await postFacebookUserAuth({
              marketId: marketPath
            });
            if (authRes.status === 'ok') {
              if (authRes.message === 'fb_user_auth_need') {
                Cookies.set('lastLocation', window.location.href, { expires: 2 });
                window.location.href = authRes.data
              } else {
                userFacebookId = authRes.data._id
                dispatch(setUserFacebookId(userFacebookId));
                catalogPublish.push(resDataObj);
              }
            } else {
              error = authRes.message;
              break;
            }
          }
          i++;
        } while (i < res.data.length);
        dispatch(setCampaignLoader(true));
        if (catalogPublish.length > 0) {
          const catalogRes = await postPublish({
            campaignId: catalogPublish[0].campaignId,
            publishType: 'facebookCatalog',
            userFacebookId: userFacebookId,
            fbBusinessId: fbBusinessId,
            fbCatalogId: catalogId,
            templateType: 'figma',
            marketId: marketPath,
            versionId: catalogPublish[0].versionId,
            facebookPropertiesId: catalogPublish[0].facebookPropertiesId,
            creativeIds: facebookCreativeIds,
          });
          if (catalogRes.status === 'err') {
            error = language[catalogRes?.code];
          }
        };
        if (scriptPublish.length > 0 && catalogPublish.length === 0) {
          scriptRes = await postPublish({
            campaignId: scriptPublish[0].campaignId,
            versionId: scriptPublish[0].versionId,
            creativeIds: facebookCreativeIds,
            publishType: 'facebookScript',
            templateType: 'figma',
            facebookPropertiesId: facebookId,
          });
          if (scriptRes.status === 'err') {
            error = language[scriptRes?.code];
          }
        }
        if (error) {
          throw error;
        }
        const updateRes = await dispatch(updateVersionStatusAfterUpdate());
        dispatch(setCampaignLoader(true));
        dispatch(setBreadcrumb({ pageTitle: 'Ad Library', title: [] }));
        await dispatch(openCampaign(currentCampaign, { ...updateRes.updatedVersion, published: 2 }))
        if (scriptRes.status === 'ok') {
          dispatch(setFacebookPublishMessage(scriptRes.data.data.result.cloudPath));
          dispatch(toggleFacebookPublishSuccessModal());
        }
        toast.success('Publish Success', { autoClose: 3000 });
      } else {
        throw res;
      }
    }
  } catch (error) {
    // console.log(error);
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    dispatch(setCampaignLoader(false));
  }
}